import { render, staticRenderFns } from "./BuyLog.vue?vue&type=template&id=08f03b8c"
import script from "./BuyLog.vue?vue&type=script&lang=js"
export * from "./BuyLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports